import React, { useState } from "react";
import NotificationsIcon from '@mui/icons-material/Notifications';
import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import CalendarModule from "../../module/Calendar";
import NotifikasiModule from "../../module/ListNotifikasi";
import DokBaruSales from "../../module/DokBaruSales";
import ListReminderSales from "../../module/ListReminderSales";
import SalesToDo from "../../module/SalesToDo";
import TaskToDo from "../../module/TaskToDo";
import Badge from '@mui/material/Badge';
import ListReminderPayment from "../../module/ListReminderPayment";
import ListDPBlmPelunasan from "../../module/ListDPBlmPelunasan";
import ListPIBlmPaid from "../../module/ListPIBlmPaid";
import KontrakAnalyst from "../../module/KontrakAnalyst";
import PIAnalyst from "../../module/PIAnalyst";
import InquiryAnalyst from "../../module/InquiryAnalyst";
import SalesReview from "../../module/SalesReview";
import ExtendRateAnalyst from "../../module/ExtendRateAnalyst";
import InquiryToPIConv from "../../module/InquiryToPIConv";
import PIConv from "../../module/PIConv";
import RevenueAnalyst from "../../module/RevenueAnalyst";
import RevenueAnalystPI from "../../module/RevenueAnalystPI";
import NewMonthlyVO from "../../module/NewMonthlyVO";
import NewRemind from "../../module/NewRemind";
import KontrakCreationReminder from "../../module/KontrakCreationReminder";
import ListKontrakBelumTTD from "../../module/ListKontrakBelumTTD";
import TungguDokComp from "../../module/TungguDokComp";
import { useSelector } from 'react-redux';
import ReminderDomisiliKokas from "../../module/ReminderDomisiliKokas";
import TotalVO from "../../module/TotalVO";
import NewInqRemindManager from "../../module/NewInqRemindManager";
import LegalTrack from "../../module/LegalTrack";
import Paper from '@mui/material/Paper';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import "./style.css";
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography } from "@mui/material";
import FURemind from "../../module/FURemind";
import NewInqRandomizer from "../../module/NewInqRandomizer";

export default function Home() {
    
    // Add a state variable to hold the selected file
    const [file, setFile] = useState(null);

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const [imageUrl, setImageUrl] = useState(null); // State to hold the URL of the image
    const navigate = useNavigate();
    const getURL = () => {
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`)
            .then(response => {
                const uploadUrl = response.data.url;
                const key = response.data.key; // assuming this is returned by your API
    
                fetch(uploadUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": file.type // Use the type of the selected file
                    },
                    body: file
                })
                .then(response => {
                    if (!response.ok) { throw response }
    
                    // Fetch the file from your backend using the `key`
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${encodeURIComponent(key)}`, {
                        responseType: 'blob' // Tell axios to get the response as a blob
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.pdf'); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        const file = new Blob([response.data], {type: 'application/pdf'});
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
                    })
                    .catch(error => {
                        console.error("Error during file retrieval:", error);
                    });
                })
                .catch(error => {
                    console.error("Error during file upload:", error);
                });
            });
    }
    
    
    
    const nowstate = useSelector(state => state);


    return (
        <Grid container>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} >
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="Home" isi="Dashboard Utama"></Header>
                </Grid>
                <Grid sx={{ mt:15}}></Grid>

                {/*........................................................Untuk Admin Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                <>
        {nowstate.user.role==="admin" && (
          <>
                <Grid container sx={{pl:5, pt:5, pb:5}} xs={12}>

                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Domisili Kokas</b></Typography>
                        <ReminderDomisiliKokas xs={12}></ReminderDomisiliKokas>
                    </Grid>
                    <Grid xs={12} sx={{mt:10}} container>
                        <Typography variant="h5" sx={{mt:1}}><b>Scheadule Meeting Hari ini</b></Typography> <Grid sx={{ml:2}}><Button variant="contained" onClick={()=>navigate("/calendar")}>Cek tanggal lain</Button></Grid>
                        <CalendarModule></CalendarModule>
                    </Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Buat Kontrak Reminder</b></Typography>
                        <KontrakCreationReminder xs={12}></KontrakCreationReminder>
                    </Grid>
                    <Grid xs={1.2}>
                        
                    </Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Tanda Tangan Kontrak</b></Typography>
                        <ListKontrakBelumTTD xs={12}></ListKontrakBelumTTD>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center" sx={{pr:9.7}}>
                        <Typography align="center"><b>Kontrak Sementara</b></Typography>
                        <TungguDokComp xs={12}></TungguDokComp>
                    </Grid>
                </Grid>
                </>)}</>
                                {/*........................................................Untuk Admin Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
 {/*........................................................Untuk Sales Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
 <>
        {nowstate.user.role==="salesold" && (
          <>
          
                <Grid container sx={{pl:5,pr:5, pt:5, pb:5}} xs={12}>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Dokumen Baru</b></Typography>
                        <DokBaruSales xs={12}></DokBaruSales>
                    </Grid>
                    <Grid xs={1.2}>
                        
                    </Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Kontrak Extend</b></Typography>
                        <ListReminderSales xs={12}></ListReminderSales>
                    </Grid>
                    <Grid xs={5} sx={{mt:5}} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Sewa Ruang Kantor</b></Typography>
                        <ListReminderPayment xs={12}></ListReminderPayment>
                    </Grid>
                    <Grid xs={1.2}>
                        
                    </Grid>
                    <Grid xs={5} sx={{mt:5}} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>DP Belum Pelunasan</b></Typography>
                        <ListDPBlmPelunasan xs={12}></ListDPBlmPelunasan>
                    </Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center" sx={{mt:5}}>
                        <Typography align="center"><b>Tanda Tangan Kontrak</b></Typography>
                        <ListKontrakBelumTTD xs={12}></ListKontrakBelumTTD>
                    </Grid>
                    <Grid xs={1.2}>
                        
                    </Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center" sx={{mt:5}}>
                        <Typography align="center"><b>PI Belum Paid</b></Typography>
                        <ListPIBlmPaid xs={12}></ListPIBlmPaid>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center" sx={{pr:9.7, mt:8}}>
                        <Typography align="center"><b>Kontrak Sementara</b></Typography>
                        <TungguDokComp xs={12}></TungguDokComp>
                    </Grid>
                    <Grid xs={4} alignItems="center" justifyContent="center" sx={{mt:8}}>
                    <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h5"><b>Total VO</b></Typography>
                        </Grid>
                        

                        <TotalVO xs={12}></TotalVO>
                    </Grid>
                    <Grid xs={2}></Grid>
                    <Grid xs={6} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h5"><b>Virtual Office Baru Satu Bulan</b></Typography>
                        </Grid>
                        <NewMonthlyVO xs={12}></NewMonthlyVO>
                    </Grid>
                </Grid>
                </>)}</>
                                {/*........................................................Untuk Sales Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                                       {/*........................................................Untuk Sales V.2 Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
 <>
        {nowstate.user.role==="salesold" && (
          <>
          
                <Grid container sx={{pl:5,pr:5, pb:5}} xs={12}>
                   
                    <Grid xs={5} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        {/* <Grid sx={{mb:2}}>
                            <Typography align="center" variant="h5"><b>Total VO</b></Typography>
                        </Grid>
                        <TotalVO xs={12}></TotalVO> */}
                        <NewInqRandomizer xs={12}></NewInqRandomizer>
                    </Grid>
                    <Grid xs={1}></Grid>
                    <Grid xs={6} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        
                        <FURemind xs={12}></FURemind>
                    </Grid>
                </Grid>
                {/* <Grid container sx={{pl:5,pr:5, pb:5}} xs={12}>
                   
                    <Grid xs={4} alignItems="center" justifyContent="center" sx={{mt:8}}>
                    </Grid>
                    <Grid xs={2}></Grid>
                    <Grid xs={6} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        <Grid sx={{mb:2}}>
                            <Typography align="center" variant="h5"><b>Virtual Office Baru Satu Bulan</b></Typography>
                        </Grid>
                        <NewMonthlyVO xs={12}></NewMonthlyVO>
                    </Grid>
                </Grid> */}
                {/* <Grid container sx={{pl:5,pr:5, pb:5}} xs={12}> */}
                {/* <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Kontrak Extend</b></Typography>
                        <ListReminderSales xs={12}></ListReminderSales>
                    </Grid> */}
                    {/* <Grid xs={2}></Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Sewa Ruang Kantor</b></Typography>
                        <ListReminderPayment xs={12}></ListReminderPayment>
                    </Grid>
                    </Grid> */}
                </>)}</>
                                {/*........................................................Untuk Sales V.2 Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}

                          {/*........................................................Untuk Sales V.3 Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                          <>
        {nowstate.user.role==="sales" && (
          <>
          
                <Grid container sx={{pl:5,pr:5, pb:5}} xs={12}>
                   
                    <Grid xs={12} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        <TaskToDo xs={12}></TaskToDo>
                    </Grid>
                </Grid>
                </>)}</>
                                {/*........................................................Untuk Sales V.3 Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                              
                                                       {/*........................................................Untuk Office Boy Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                <>
        {nowstate.user.role==="cleaning" && (
          <>
                <Grid container sx={{pl:5, pt:5, pb:5}} xs={12}>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Reminder Notifikasi</b></Typography>
                        <NotifikasiModule xs={12}></NotifikasiModule>
                    </Grid>
                    <Grid xs={1.2}>
                        
                    </Grid>
                    <Grid xs={5} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Domisili Kokas</b></Typography>
                        <ReminderDomisiliKokas xs={12}></ReminderDomisiliKokas>
                    </Grid>
                    <Grid xs={12} sx={{mt:10}} container>
                    <Typography variant="h5" sx={{mt:1}}><b>Scheadule Meeting Hari ini</b></Typography> <Grid sx={{ml:2}}><Button variant="contained" onClick={()=>navigate("/calendar")}>Cek tanggal lain</Button></Grid>
                        <CalendarModule></CalendarModule>
                    </Grid>
                </Grid>
                </>)}</>
                                {/*........................................................Untuk Office Boy Vieww/Dashboard yaaaaaaa 
                                               
                                               
                                               
                                               
                                               
                                               
                                                {/*........................................................Untuk Management Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                                <>
        {nowstate.user.role==="owner" && (
          <>
                <Grid container sx={{pl:5,pr:5, pt:5, pb:5}} xs={12}>
                    <Grid xs={12} alignItems="center" justifyContent="center" style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Extend Rate</b></Typography>
                        </Grid>
                        <ExtendRateAnalyst xs={12}></ExtendRateAnalyst>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center" style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Inquiry Counter</b></Typography>
                        </Grid>
                        <InquiryAnalyst xs={12}></InquiryAnalyst>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center" style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Sales Review</b></Typography>
                        </Grid>
                        <SalesReview xs={12}></SalesReview>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center" style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Inquiry Rate</b></Typography>
                        </Grid>
                        <InquiryToPIConv xs={12}></InquiryToPIConv>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center"  style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                    <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>PI Counter</b></Typography>
                        </Grid>                        
                        <PIAnalyst xs={12}></PIAnalyst>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center" style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>PROFORMA INVOICE CONVERSION</b></Typography>
                        </Grid>
                        <PIConv xs={12}></PIConv>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center"  style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                    <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Kontrak Counter</b></Typography>
                        </Grid>
                        

                        <KontrakAnalyst xs={12}></KontrakAnalyst>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center"  style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                    <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Revenue Analysis</b></Typography>
                        </Grid>
                        

                        <RevenueAnalyst xs={12}></RevenueAnalyst>
                    </Grid>
                    <Grid xs={12} alignItems="center" justifyContent="center"  style={{ transform: 'scale(0.8)',  transformOrigin: 'center' }}>
                    <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h4"><b>Revenue Analysis Paid Invoice</b></Typography>
                        </Grid>
                        

                        <RevenueAnalystPI xs={12}></RevenueAnalystPI>
                    </Grid>
                    <Grid xs={6} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h5"><b>Virtual Office Baru Satu Bulan</b></Typography>
                        </Grid>
                        <NewMonthlyVO xs={12}></NewMonthlyVO>
                    </Grid>

                    <Grid xs={6} alignItems="center" justifyContent="center" sx={{mt:8}}>
                        <Grid sx={{mb:2}}>
                        <Typography align="center" variant="h5"><b>Inquiry Manager</b></Typography>
                        </Grid>
                        <NewInqRemindManager xs={12}></NewInqRemindManager>
                    </Grid>
                    
                    
                    
                </Grid>
</>
        )}</>
                                 {/*........................................................Untuk legal Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                 <>
        {nowstate.user.role==="legal" && (
          <>
                <Grid container sx={{pl:5, pt:5, pb:5}} xs={12}>
                    <Grid xs={12} alignItems="center" justifyContent="center">
                        <Typography align="center"><b>Reminder Notifikasi</b></Typography>
                        <LegalTrack xs={12}></LegalTrack>
                    </Grid>
                    
                </Grid>
                </>)}</>
        
        
            </Grid>
        </Grid>
    );
}
